import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-update-intermediate',
  templateUrl: './update-intermediate.component.html',
  styleUrls: ['./update-intermediate.component.scss']
})
export class UpdateIntermediateComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
